export default "__VITE_ASSET__DYOK_XS9__"